import homeIcon from '../assets/navbar-icons/home.svg';
import projectsIcon from '../assets/navbar-icons/projects.svg';
import contactIcon from '../assets/navbar-icons/contact.svg';

export const NAV_ITEMS = [
  { text: 'Home', link: '/', icon: homeIcon },
  { text: 'Projects', link: '/projects', icon: projectsIcon },
  { text: 'Contact', link: '/contact', icon: contactIcon },
];

